import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Form, FormCategory, FormStatus, Grade, Heading, Subject, Tag, TagSetting } from '../../../../core';
export var FormApiMapper = /*#__PURE__*/function () {
  function FormApiMapper(sectionApiMapper) {
    _classCallCheck(this, FormApiMapper);

    this.sectionApiMapper = sectionApiMapper;
  }

  _createClass(FormApiMapper, [{
    key: "toDomain",
    value: function toDomain(formDto) {
      var _formDto$sections,
          _this = this,
          _formDto$totalQuestio;

      var props = {
        id: formDto.id,
        title: formDto.title,
        description: formDto.description,
        folderId: formDto.folderId,
        coverImage: formDto.coverImage,
        status: FormStatus.Active,
        sections: (_formDto$sections = formDto.sections) === null || _formDto$sections === void 0 ? void 0 : _formDto$sections.map(function (s) {
          return _this.sectionApiMapper.toDomain(formDto.id, s);
        }),
        version: formDto.version,
        updatedAt: formDto === null || formDto === void 0 ? void 0 : formDto.updatedAt,
        createdBy: formDto === null || formDto === void 0 ? void 0 : formDto.createdBy,
        thumbnail: (formDto === null || formDto === void 0 ? void 0 : formDto.thumbnail) || '',
        hasEssayOrFillInBlankQuestion: formDto.hasEssayOrFillInBlankQuestion,
        totalQuestions: (_formDto$totalQuestio = formDto.totalQuestions) !== null && _formDto$totalQuestio !== void 0 ? _formDto$totalQuestio : formDto.totalQuestion,
        totalQuestion: formDto.totalQuestion,
        totalScore: formDto.totalScore
      };

      if (formDto.headings) {
        props.headings = formDto.headings.map(function (heading) {
          return Heading.create({
            title: heading.title,
            description: heading.description,
            formId: formDto.id,
            sectionId: heading.sectionId,
            nextQuestionId: heading.nextQuestionId,
            previousHeadingId: heading.previousHeadingId,
            nextHeadingId: heading.nextHeadingId,
            previousQuestionId: heading.previousQuestionId
          }, heading.id.toString()).getValue();
        });
      }

      if (formDto.category) {
        props.category = FormCategory.create({
          id: formDto.category.id,
          key: formDto.category.key,
          status: formDto.category.status,
          possibleQuestionCreationTypes: formDto.category.possibleQuestionCreationTypes,
          tagSettings: formDto.category.tagSettings ? formDto.category.tagSettings.map(function (tag) {
            return TagSetting.create(_objectSpread({}, tag)).getValue();
          }) : []
        }).getValue();
      }

      if (formDto.subjects) {
        props.subjects = formDto.subjects.map(function (sub) {
          return Subject.create({
            id: sub.id,
            key: sub.key,
            translation: sub.translation
          }).getValue();
        });
      }

      if (formDto.grades) {
        props.grades = formDto.grades.map(function (grade) {
          return Grade.create({
            id: grade.id,
            key: grade.key,
            translation: grade.translation
          }).getValue();
        });
      }

      if (formDto.grades) {
        props.grades = formDto.grades.map(function (grade) {
          return Grade.create({
            id: grade.id,
            key: grade.key,
            translation: grade.translation
          }).getValue();
        });
      }

      if (formDto.tags) {
        props.tags = formDto.tags.map(function (t) {
          return Tag.create({
            id: t.id,
            key: t.key
          }).getValue();
        });
      }

      return Form.create(props).getValue();
    }
  }]);

  return FormApiMapper;
}();